import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { closeModal, ToastMain ,SweetAlertShow} from "../master/Master";
import HostelHeader from "./HostelHeader";
import Nav from "../master/NavBar";
import { BankAdd, BankDelete, BankList, BankUpdate } from "../../api/BankService";
export default function HostelBankAccount() {
  const [loading, setLoading] = useState(false);
  const [Banks, setBanks] = useState([]);
  const [modalData, setModelData] = useState('')


  const BankCreate = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      const formData = new FormData(e.target);
      const response = await BankAdd(formData);
      if (response?.data?.status) {
        closeModal('BankAdd')
        e.target.reset();
        // ToastMain.fire({
        //   icon: 'success',
        //   title: response?.data?.message || 'successfully'
        // })

        SweetAlertShow('success','Successfully',response?.data?.message)
        getBusinessBanks();
      } else {
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'something went wrong'
        // })
        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: 'error',
      //   title: error?.response?.data?.message || 'something went wrong'
      // })
      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.message)
    } finally {
      setLoading(false)
    }
  }

  const getBusinessBanks = async () => {
    setLoading(true)
    try {
      const response = await BankList();
      if (response?.data?.status) {
        setBanks(response?.data?.data)
      } else {
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'something went wrong'
        // })
        SweetAlertShow('info','Warning',response?.data?.message )
      }

    } catch (error) {
      // ToastMain.fire({
      //   icon: 'error',
      //   title: error?.response?.data?.message || 'something went wrong'
      // })

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.message)
    } finally {
      setLoading(false)
    }
  }

  const updateBankDetails = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      const formData = new FormData(e.target);
      const response = await BankUpdate(formData);
      if (response?.data?.status) {
        closeModal('BankUpdate')
        e.target.reset();
        // ToastMain.fire({
        //   icon: 'success',
        //   title: response?.data?.message || 'successfully'
        // })
        SweetAlertShow('success','Successfully',response?.data?.message)
        getBusinessBanks();
      } else {
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'something went wrong'
        // })

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: 'error',
      //   title: error?.response?.data?.message || 'something went wrong'
      // })
      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.message)
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to undo this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    });

    if (result.isConfirmed) {
      setLoading(true);
      try {
        const response = await BankDelete(id);
        if (response.data.status == true) {
          // ToastMain.fire({
          //   icon: 'success',
          //   title: response?.data?.message || 'successfully'
          // })

          SweetAlertShow('success','successfully', response?.data?.message)
          getBusinessBanks();
        } else {
          // ToastMain.fire({
          //   icon: 'info',
          //   title: response?.data?.message || 'something went wrong'
          // })

          SweetAlertShow('info','Warning', response?.data?.message)
        }
      } catch (err) {
    //      ToastMain.fire({
    //   icon:'error',
    //   title: err?.response?.data?.message || 'something went wrong'
    //  })

     SweetAlertShow('error','Error',err?.response?.data?.message  ?? err?.message)
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    getBusinessBanks();

  }, [])


  return (
    <>
{loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <HostelHeader />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-item-center">
                      <h4>Business Banks</h4>
                      <div className="d-flex">
                      <Link to={'/hostel/banks/fund/transfer'} className="btn btn-sm btn-outline-primary mb-3 ">Fund Transfer</Link>
                      <button className="btn btn-sm btn-primary mb-3 ms-2" data-bs-toggle='modal' data-bs-target='#BankAdd' >Add</button>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table border table-bordered ">
                        <thead className="table-primary">
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Account Number</th>
                            <th>IFSC Code</th>
                            <th>Branch</th>
                            <th>Current Amount</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Banks?.map((item, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{item.owner_name}</td>
                              <td>{item.account_no}</td>
                              <td>{item.ifsc_code}</td>
                              <td>{item.branch}</td>
                              <td>{item.amount}</td>
                              <td>
                                <button
                                  className="btn btn-sm me-1 btn-outline-info"
                                  data-bs-toggle="modal"
                                  data-bs-target="#BankUpdate"
                                  onClick={() => setModelData(item)}
                                >
                                  <i className="ri-edit-circle-line"></i>
                                </button>
                                <button
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => handleDelete(item?.id)}
                                >
                                  <i className="ri-delete-bin-6-fill"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bank Add Modal */}

      <div
        className="modal fade"
        id="BankAdd"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header  p-3 bg-label-primary">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Bank Details
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <form onSubmit={BankCreate} >
              <div className="modal-body">
                <div className="row g-3">
                  {/* Title */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        name="account_no"
                        id="account_no"
                        className="form-control"
                        placeholder=" Account Number"
                        required
                        onChange={(e) =>
                          (e.target.value = e.target.value.toUpperCase())
                        }
                      />
                      <label htmlFor="account_no">Account Number</label>
                    </div>
                  </div>

                  {/* Customer Rate */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        name="ifsc_code"
                        id="ifsc_code"
                        className="form-control"
                        placeholder="Enter Ifsc Code"
                      />
                      <label htmlFor="ifsc_code">IFSC Code</label>
                    </div>
                  </div>

                  {/* Description */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        name="owner_name"
                        id="owner_name"
                        className="form-control input-uppercase"
                        placeholder="Enter Owner Name"
                        onChange={(e) =>
                          (e.target.value = e.target.value.toUpperCase())
                        }
                      />
                      <label htmlFor="owner_name">Owner Name</label>
                    </div>
                  </div>

                  {/* Branch */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        name="branch"
                        id="branch"
                        className="form-control input-uppercase"
                        placeholder="Enter Branch Name"
                        onChange={(e) =>
                          (e.target.value = e.target.value.toUpperCase())
                        }
                      />
                      <label htmlFor="branch">Branch</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        name="amount"
                        id="amount"
                        className="form-control"
                        placeholder="Enter Amount"
                        step="any"
                        min="0"
                        onChange={(e) =>
                          (e.target.value = e.target.value.toUpperCase())
                        }
                      />
                      <label htmlFor="amount">Amount</label>
                    </div>
                  </div>


                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Save Category
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Bank Update Modal */}

      <div
        className="modal fade"
        id="BankUpdate"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header  p-3 bg-label-primary">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Bank Details Update
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <form onSubmit={updateBankDetails} >
              <div className="modal-body">
                <input type="hidden" name="id" value={modalData?.id ?? 0} />
                <div className="row g-3">
                  {/* Title */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        name="account_no"
                        id="account_no"
                        className="form-control"
                        placeholder=" Account Number"
                        defaultValue={modalData?.account_no}
                        required

                      />
                      <label htmlFor="account_no">Account Number</label>
                    </div>
                  </div>

                  {/* Customer Rate */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        name="ifsc_code"
                        id="ifsc_code"
                        className="form-control"
                        placeholder="Enter Ifsc Code"
                        defaultValue={modalData?.ifsc_code}
                      />
                      <label htmlFor="ifsc_code">IFSC Code</label>
                    </div>
                  </div>

                  {/* Description */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        name="owner_name"
                        id="owner_name"
                        className="form-control input-uppercase"
                        placeholder="Enter Owner Name"
                        defaultValue={modalData?.owner_name}
                        onChange={(e) =>
                          (e.target.value = e.target.value.toUpperCase())
                        }
                      />
                      <label htmlFor="owner_name">Owner Name</label>
                    </div>
                  </div>

                  {/* Branch */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        name="branch"
                        id="branch"
                        className="form-control input-uppercase"
                        placeholder="Enter Branch Name"
                        defaultValue={modalData?.branch}
                        onChange={(e) =>
                          (e.target.value = e.target.value.toUpperCase())
                        }
                      />
                      <label htmlFor="branch">Branch</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        name="amount"
                        id="amount"
                        className="form-control"
                        placeholder="Enter Amount"
                        defaultValue={modalData?.amount}
                        step="any"
                        min="0"
                        onChange={(e) =>
                          (e.target.value = e.target.value.toUpperCase())
                        }
                      />
                      <label htmlFor="amount">Amount</label>
                    </div>
                  </div>


                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Save Category
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

    </>
  );
}
